
import AuthService from './services/AuthService.js'
import PasswordCrypter from '@/utils/password-crypter.js'
import UserService from './services/UserService'
import FirebaseService from './services/FirebaseService'

import UserSalaryService from './services/UserSalaryService'
import UserPositionService from './services/UserPositionService'
import UserDepartmentService from './services/UserDepartmentService'
import AnnouncementService from './services/AnnouncementService'
import CountyService from './services/CountyService'
import ClientService from './services/ClientService'
import DepartmentService from './services/DepartmentService'
import ProjectService from './services/ProjectService'
import ProjectGanttTaskService from './services/ProjectGanttTaskService'
import ProjectDepartmentBudgetService from './services/ProjectDepartmentBudgetService'
import TaskService from './services/TaskService'
import TaskWorkingItemService from './services/TaskWorkingItemService'
import ReceiptService from './services/ReceiptService'
import TodoItemService from './services/TodoItemService'
import NotificationService from './services/NotificationService'
import DeviceInfoService from './services/DeviceInfoService'
import SalaryService from './services/SalaryService'
import WorkOrderService from './services/WorkOrderService'
import LeaveFormService from './services/LeaveFormService'
import CompensatoryTimeService from './services/CompensatoryTimeService'

import Config from '@/data/config.js'

export default class Services {

    constructor() {
        this.isFetching = false
        this.isFetched = false
        this.lastFetchedAtTs = null

        this.firebase = new FirebaseService('biiu')

        this.reset();
    }

    reset() {
        let passwordCrypter = new PasswordCrypter(Config.SaltBefore, Config.SaltAfter)
        this.auth = new AuthService(passwordCrypter)
        this.user = new UserService(passwordCrypter)
        this.userSalary = new UserSalaryService()
        this.userPosition = new UserPositionService()
        this.userDepartment = new UserDepartmentService()
        // this.firebase = new FirebaseService()
        // this.contentTemplate = new ContentTemplateService()
        // this.post = new PostService()
        // this.news = new NewsService()
        // this.faq = new FaqService()
        // this.webInfo = new WebInfoService()
        // this.message = new MessageService()
        this.announcement = new AnnouncementService()
        this.county = new CountyService()
        this.client = new ClientService()
        this.department = new DepartmentService()
        this.project = new ProjectService()
        this.projectGanttTaskService = new ProjectGanttTaskService()
        this.projectDepartmentBudget = new ProjectDepartmentBudgetService()
        this.task = new TaskService()
        this.taskWorkingItem = new TaskWorkingItemService()
        this.receipt = new ReceiptService()
        this.todoItem = new TodoItemService()
        this.notification = new NotificationService()
        this.deviceInfo = new DeviceInfoService()
        this.salary = new SalaryService()
        this.workOrder = new WorkOrderService()
        this.leaveForm = new LeaveFormService()
        this.compensatoryTime = new CompensatoryTimeService()
    }

    prepareDatas(vm) {
        window.console.log(`services prepareDatas`)
        return new Promise((resolve, reject) => {
            if (this.isFetched) {
                window.console.log(`services prepareDatas, isFetched`)
                // 如果已經 fetch 超過5分鐘，也可以fetch!
                let now = (new Date()).getTime()
                window.console.log(`services prepareDatas, isFetched, now=`,now)
                let threashold = 5*1000//5*60*1000
                if (this.lastFetchedAtTs === null || (now - this.lastFetchedAtTs) > threashold) {
                    // still fetch again!
                    window.console.log(`services prepareDatas, isFetched, still fetch again`)
                } else {
                    window.console.log(`services prepareDatas, isFetched, resolve`)
                    return resolve()
                }
            }
            if (this.isFetching) {
                window.console.log(`services prepareDatas, isFetching`)
                var timer = setInterval(() => {
                    if (this.isFetching) return  window.console.log(`services prepareDatas, isFetching return`)
                    clearInterval(timer)
                    if (this.isFetched) {
                        window.console.log(`services prepareDatas, isFetching, isFetched`)
                        resolve()
                    } else {
                        window.console.log(`services prepareDatas, isFetching, reject`)
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            window.console.log(`services prepareDatas, isFetching, fetch...`)
            var promiseList =
            [
                this.user.prepareData(vm),
                this.userPosition.prepareData(vm),
                this.userDepartment.prepareData(vm),// department required
                this.userSalary.prepareData(vm),
                this.department.prepareData(vm),
                this.announcement.prepareData(vm),
                this.notification.prepareData(vm),
                this.leaveForm.prepareData(vm),
                this.compensatoryTime.prepareData(vm),
                this.prepareProjectDatas(vm),
                this.workOrder.prepareData(vm)
                // 工作日誌 ???
            ]
            this.isFetching = true
            return Promise.all(promiseList).
                then(result => {
                    var promiseLits2 = []
                    if (vm.$store.getters.myLevel >= 10) {
                        promiseLits2.push(this.todoItem.prepareData(vm))
                    }
                    if (promiseLits2.length > 0) return Promise.all(promiseLits2)
                    return result
                })
                .then(res => {
                    this.lastFetchedAtTs = (new Date()).getTime()
                    this.isFetched = true
                    return res
                })
                .then(res => {
                    this.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    this.isFetching = false
                    reject(err)
                })
        })
    }

    prepareProjectDatas(vm) {
        return Promise.all([
            this.client.prepareData(vm),
            this.county.prepareData(vm),
            this.department.prepareData(vm),
            this.project.prepareData(vm),
            this.projectDepartmentBudget.prepareData(vm),
            this.task.prepareData(vm),
            this.taskWorkingItem.prepareData(vm),
        ])
    }

    alertResultError(vm, res) {
        var msg = '未知的錯誤'
        if (res && res.data && res.data.error) msg = res.data.error
        alert(msg, '錯誤', {
            confirmButtonText: '確認',
            type: 'error'
        })
    }

    alertError(vm, err) {
        window.console.error(err)
        var msg = err
        if (err.response && err.response.data && err.response.data.error) msg = err.response.data.error
        else if (err.response) msg = (err.response.status || '') + ' ' + (err.response.statusText || '沒有錯誤訊息')
        else if (err.isAxiosError && err.message) msg = err.message
        else msg = '未知的錯誤'

        alert(msg, '錯誤', {
            confirmButtonText: '確認',
            type: 'error'
        })
    }
}
